import { render } from "./Steps2.vue?vue&type=template&id=3346a1ce"
import script from "./Steps2.vue?vue&type=script&lang=js"
export * from "./Steps2.vue?vue&type=script&lang=js"
script.render = render

export default script